import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { createApiCaller } from '../../infrastructure/api/ApiFactory';
import { PageWrapper } from '../../uiComponents/layout/PageWrapper';
import { PageTitle } from '../../uiComponents/layout/PageTitle';
import Tabs from '../../uiComponents/layout/Tabs';
import TabContent from '../../uiComponents/layout/TabContent';
import KonkurrenceOpgavePresenter from './KonkurrenceOpgavePresenter';
import { Spinner } from '../../uiComponents/Spinner';
import KonkurrenceOpgaveOftestStilledeSpoergsmaal from './KonkurrenceOpgaveOftestStilledeSpoergsmaal';
import KonkurrenceLogbogContainer from './KonkurrenceLogbogContainer';
import { DetailedOpgavepakkeOpgave } from '../../models/DetailedOpgavepakkeOpgave';
import { LogbogIndlaeg } from '../../models/LogbogIndlaeg';
import { OpretLogbogIndlaeg } from '../../models/OpretLogbogIndlaeg';
import IApiCaller from '../../infrastructure/api/IApiCaller';
import { OpgavepakkeOpgaveListItem } from '../../models/OpgavepakkeOpgaveListItem';
import { SelectFormControl } from '../../uiComponents/bootstrap-components/BootstrapComponents';
import { Guid } from '../../infrastructure/Guid';
import { PrintButton } from '../../uiComponents/input/Buttons';
import { Konkurrence } from '../../models/Konkurrence';

export interface KonkurrenceOpgaveContainerProps extends RouteComponentProps<any> { }

interface KonkurrenceOpgaveState {
    selectedOpgavepakkeopgave?: DetailedOpgavepakkeOpgave;
    opgavepakkeOpgaver?: OpgavepakkeOpgaveListItem[];
    selectedTabName: string;
    konkurrence?: Konkurrence;
}

class KonkurrenceOpgaveContainer extends React.Component<KonkurrenceOpgaveContainerProps,
    KonkurrenceOpgaveState> {

    private _pageTabs: Map<number, string>;
    private _tabContent: any[];
    private _holdId: string = Guid.empty();

    constructor(props: KonkurrenceOpgaveContainerProps) {
        super(props);

        this.state = {
            opgavepakkeOpgaver: undefined,
            selectedOpgavepakkeopgave: undefined,
            selectedTabName: this.props.match.params.tab
        };

        this.setStateFromResponse = this
            .setStateFromResponse
            .bind(this);

        this.onTabChanged = this.onTabChanged.bind(this);
    }

    public get tabContent(): any[] {
        return this._tabContent;
    }
    public set tabContent(v: any[]) {
        this._tabContent = v;
    }

    public get pageTabs(): Map<number, string> {
        return this._pageTabs;
    }
    public set pageTabs(v: Map<number, string>) {
        this._pageTabs = v;
    }

    componentDidMount() {
        let self = this;
        let konkurrenceId = this.props.match.params.konkurrenceId;
        let opgavePakkeOpgaveId = this.props.match.params.opgavePakkeOpgaveId;
        this._holdId = this.props.match.params.holdId;
        let apiCaller = createApiCaller();

        if (konkurrenceId !== undefined && konkurrenceId.length > 0 && opgavePakkeOpgaveId !== undefined && opgavePakkeOpgaveId.length > 0) {
            apiCaller.getKonkurrence(konkurrenceId).then(data => this.setState({
                konkurrence: data
            }));
            if (opgavePakkeOpgaveId !== undefined && opgavePakkeOpgaveId.length > 0) {
                self.getContentFromApi(apiCaller, konkurrenceId, opgavePakkeOpgaveId, self._holdId)
                    .then(response => {
                        this.setStateFromResponse(response, opgavePakkeOpgaveId);
                    });
            }
        }
    }

    getContentFromApi = (apiCaller: IApiCaller, konkurrenceId: string, opgavepakkeOpgaveId: string, holdId: string) => {
        return apiCaller
            .getDetailedOpgave(konkurrenceId, opgavepakkeOpgaveId, holdId);
    }

    setStateFromResponse(konkurrenceOpgave: DetailedOpgavepakkeOpgave, selectedOpgavepakkeOpgaveId: string) {
        this.setState({ opgavepakkeOpgaver: konkurrenceOpgave.opgavepakkeOpgaver, selectedOpgavepakkeopgave: konkurrenceOpgave });
    }

    updateLogbogIndlaeg = (logbogIndlaeg: LogbogIndlaeg) => {
        return new Promise((resolve, reject) => {
            let apiCaller = createApiCaller();
            let konkurrenceId = this.props.match.params.konkurrenceId;
            let opgavepakkeOpgaveId = this.state.selectedOpgavepakkeopgave !== undefined ? this.state.selectedOpgavepakkeopgave.opgavepakkeOpgaveId : '';

            if (opgavepakkeOpgaveId !== undefined) {
                apiCaller.updateLogbogIndlaeg(logbogIndlaeg)
                    .then(response => {
                        this.getContentFromApi(apiCaller, konkurrenceId, opgavepakkeOpgaveId, this._holdId)
                            .then(res => {
                                this.setStateFromResponse(res, opgavepakkeOpgaveId);
                                resolve();
                            });
                    });
            }
        });
    }

    createLogbogIndlaeg = (logbogAfsnitId: string, logbogIndlaeg: LogbogIndlaeg) => {
        return new Promise((resolve, reject) => {
            // send create kald til API
            var apiCaller = createApiCaller();
            let model = new OpretLogbogIndlaeg();
            model.holdId = this._holdId;
            model.logbogAfsnitId = logbogAfsnitId;
            model.opgavepakkeOpgaveId = this.state.selectedOpgavepakkeopgave !== undefined ? this.state.selectedOpgavepakkeopgave.opgavepakkeOpgaveId : this.props.match.params.opgavePakkeOpgaveId;
            model.logbogIndlaeg = logbogIndlaeg;

            let konkurrenceId = this.props.match.params.konkurrenceId;
            let opgavepakkeOpgaveId = model.opgavepakkeOpgaveId;

            // hent indhold igen og set state        
            apiCaller.createLogbogIndlaeg(model)
                .then(response => {
                    this.getContentFromApi(apiCaller, konkurrenceId, opgavepakkeOpgaveId, this._holdId)
                        .then(res => {
                            this.setStateFromResponse(res, opgavepakkeOpgaveId);
                            resolve();
                        });
                });
        });
    }

    getPageTitle() {
        return this.state.selectedOpgavepakkeopgave !== undefined
            ? this.state.selectedOpgavepakkeopgave.opgave.titel
            : '';
    }

    getRedirectUrl(opgavepakkeOpgaveId: string): string {
        var konkurrenceId = this.props.match.params.konkurrenceId;
        return '/konkurrence/' + konkurrenceId + '/hold/' + this._holdId + '/opgavepakkeopgave/' + opgavepakkeOpgaveId;
    }

    constructTabs() {
        let tabs = new Map<number,
            string>();
        let tabContents = new Array();

        if (this.state.selectedOpgavepakkeopgave !== undefined) {
            tabs.set(0, 'Opgave');

            let konkurrenceDag = this.state.konkurrence !== undefined && this.state.konkurrence !== null ? this.state.konkurrence.startdato : undefined;
            let konkurrenceStatus = this.state.konkurrence !== undefined && this.state.konkurrence !== null ? this.state.konkurrence.status : undefined;

            tabContents.push((
                <TabContent tabName='0' defaultActive={this.state.selectedTabName === 'opgave'}>
                    <PrintButton text='Udskriv' />
                    <KonkurrenceOpgavePresenter
                        opgave={this.state.selectedOpgavepakkeopgave.opgave}
                        konkurrenceId={this.props.match.params.konkurrenceId}
                        konkurrenceDag={konkurrenceDag}
                        konkurrenceStatus={konkurrenceStatus}
                        readonly={this.state.selectedOpgavepakkeopgave.readonly}
                    />
                </TabContent>
            ));

            if (this.state.selectedOpgavepakkeopgave.logbog !== undefined && this.state.selectedOpgavepakkeopgave.logbog !== null) {
                tabs.set(1, 'Logbog');

                tabContents.push((
                    <TabContent tabName='1' defaultActive={this.state.selectedTabName === 'logbog'}>
                        <KonkurrenceLogbogContainer
                            createIndlaeg={this.createLogbogIndlaeg}
                            updateIndlaeg={this.updateLogbogIndlaeg}
                            logbog={this.state.selectedOpgavepakkeopgave.logbog}
                        />
                    </TabContent>
                ));
            }
            if (this.state.selectedOpgavepakkeopgave.opgave.oftestStilledeSpoergsmaalIndhold !== undefined && this.state.selectedOpgavepakkeopgave.opgave.oftestStilledeSpoergsmaalIndhold !== null) {
                tabs.set(2, 'Oftest stillede spørgsmål');
                tabContents.push((
                    <TabContent tabName='2' defaultActive={this.state.selectedTabName === 'ofteststilledespoergsmaal'}>
                        <KonkurrenceOpgaveOftestStilledeSpoergsmaal opgave={this.state.selectedOpgavepakkeopgave.opgave} />
                    </TabContent>
                ));
            }
        }

        this.pageTabs = tabs;
        this.tabContent = tabContents;
    }

    getTabContents() {
        return this.tabContent;
    }

    onOpgavepakkeOpgaveSelectChange = (e: any) => {
        let apiCaller = createApiCaller();
        let opgavepakkeOpgaveId = e.target.value;
        this.setState({ selectedOpgavepakkeopgave: undefined });
        this.getContentFromApi(apiCaller, this.props.match.params.konkurrenceId, opgavepakkeOpgaveId, this._holdId)
            .then(response => {
                this.setStateFromResponse(response, opgavepakkeOpgaveId);
                const url = this.getRedirectUrl(opgavepakkeOpgaveId) + '/' + this.state.selectedTabName;
                this.props.history.push(url);
            });
    }

    getActiveTabIndex(): number {
        var tab = this.state.selectedTabName;
        switch (tab) {
            case 'opgave':
                return 0;
            case 'logbog':
                return 1;
            case 'ofteststilledespoergsmaal':
                return 2;
            default:
                return 0;
        }
    }

    getOpgavepakkeOpgaveSelect = () => {
        if (this.state.selectedOpgavepakkeopgave !== undefined && this.state.opgavepakkeOpgaver !== undefined && this.state.opgavepakkeOpgaver.length > 0) {
            const opgaveList = this.state.opgavepakkeOpgaver
                .map((o, i) => {
                    return <option key={o.id} value={o.id}>{o.name}</option>;
                });
            return (
                <SelectFormControl value={this.state.selectedOpgavepakkeopgave.opgavepakkeOpgaveId} onChange={this.onOpgavepakkeOpgaveSelectChange} className='opgavepakkeopgave-select'>
                    {opgaveList}
                </SelectFormControl>
            );
        }

        return undefined;
    }

    onTabChanged(changedKey: number) {
        let tabName = 'opgave';
        switch (changedKey) {
            case 0:
                tabName = 'opgave';
                break;
            case 1:
                tabName = 'logbog';
                break;
            case 2:
                tabName = 'ofteststilledespoergsmaal';
                break;
            default:
                break;
        }

        this.setState({ selectedTabName: tabName });

        this.pushTabHistory(tabName);
    }

    pushTabHistory(tabName: string) {
        const url = this.getRedirectUrl(this.props.match.params.opgavePakkeOpgaveId) + '/' + tabName;
        this.props.history.push(url);
    }

    render() {

        this.constructTabs();

        if (this.state.selectedOpgavepakkeopgave === undefined || this.state.konkurrence === undefined) {
            return <Spinner />;
        } else {
            return (
                <PageWrapper className='opgave-visning'>
                    <PageTitle title={this.getPageTitle()}>
                        {this.getOpgavepakkeOpgaveSelect()}
                    </PageTitle>
                    <Tabs columns={this.pageTabs} defaultColumnKey={this.getActiveTabIndex()} onTabChanged={this.onTabChanged}>
                        {this.getTabContents()}
                    </Tabs>
                </PageWrapper>
            );
        }
    }
}

export default KonkurrenceOpgaveContainer;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/konkurrence/KonkurrenceOpgaveContainer.tsx